export default function FourOhFour() {
  return (
    <h1 style={{ textAlign: 'center' }}>Oh no, page not found!</h1>
  )
}
